export enum SubscriberStatus {
    PAID = 'PAID',
    FREE_TRIAL = 'FREE_TRIAL',
}
